<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	mounted() {
		if (window.innerHeight < 750) {
			const { query } = this.$route;
			if (query) {
				const { song } = query;
				if (song) {
					//window.location.replace("exp://192.168.1.12:19000/?song=" + song);
					window.location.replace("alduin://?song=" + song);
				}
			}
		}
	},
};
</script>

<style>
@import "./assets/globalstyle.css";
</style>
